import { ReactElement } from "react";
import {
  FreeFormAddressFieldConfig,
  FreeFormAddressElementType,
} from "@evergiving/common/dist/es2015/form";
import { notNil } from "@evergiving/common/dist/es2015/typescriptUtils";

import { FormField } from "@/lib/components/FormField";

export function FreeFormAddressComponent({
  freeFormAddressFieldConfig,
}: {
  freeFormAddressFieldConfig: FreeFormAddressFieldConfig;
}): ReactElement {
  return (
    <>
      {Object.entries(freeFormAddressFieldConfig)
        .map(([key, value]) => {
          const mayBeElementType:
            | FreeFormAddressElementType
            | undefined = Object.entries(FreeFormAddressElementType).find(
            ([_, v]) => v === key
          )?.[1];
          if (!mayBeElementType || !value) {
            return null;
          }
          return <FormField name={mayBeElementType} key={key} config={value} />;
        })
        .filter(notNil)}
    </>
  );
}
